import React, { Component } from 'react';
import Map from './containers/Map/Map';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { NavLink, Route, Switch } from 'react-router-dom';
import Stats from './containers/Stats/Stats';

class App extends Component {
  render() {
    return (
      <div className="App">
          <Header/>
          <Switch>
             <Route exact path="/">
                 <Map/>
             </Route>
             <Route exact path="/stats">
                 <Stats/>
             </Route> 
           </Switch>
           <Footer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js